export const EM_DASH = '\u2014';

export const formatDaysValue = (days: number | null | undefined): string => {
  if (days == null || isNaN(days)) return EM_DASH;
  return `${days.toFixed(1)} days`;
};

export const formatPercentage = (value: number | null | undefined, decimals = 1): string => {
  if (value == null || isNaN(value)) return EM_DASH;
  return `${value.toFixed(decimals)}%`;
};

export const formatDecimal = (value: number | null | undefined): string => {
  if (value == null || isNaN(value)) return EM_DASH;
  return value.toFixed(1);
};

export const formatWholeNumber = (value: number | null | undefined): string => {
  if (value == null || isNaN(value)) return EM_DASH;
  return String(value);
};

export const formatResponseTime = (
  seconds: number | null | undefined,
  { compact }: { compact?: boolean } = {}
): string => {
  if (seconds == null || isNaN(seconds)) return EM_DASH;
  const totalMinutes = Math.round(seconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours === 0 && minutes === 0) return compact ? '<1m' : '<0h 1m';
  return `${hours}h ${minutes}m`;
};
